export enum StrainMeasurementStatus {
    OK = 0,
    NOK = 1,
    NotDone = 2,
    InProgress = 3
}
